import axios from '@/config/httpConfig'

// 添加或更新对象记录
export function save(data) {
  return axios.post('/objectInfo/save', data)
}
